import React, { PureComponent } from 'react';

import Icon from  './icon';

const WIDTH = 1;
const HEIGHT = 1;

const Element = ({ className, getSize, color, style }) => (
    <svg className={className} style={style} width={getSize(WIDTH)} height={getSize(HEIGHT)} viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <path fill={color} d="M8 14.5c3.59 0 6.5-2.91 6.5-6.5S11.59 1.5 8 1.5a6.499 6.499 0 0 0-6.48 7.01l-1.465.43A8 8 0 0 1 8 0a8 8 0 0 1 8 8 8 8 0 0 1-8.94 7.944l.43-1.463c.17.013.338.019.51.019Zm.372-3.019A3.502 3.502 0 0 0 11.5 8c0-1.934-1.566-3.5-3.5-3.5a3.502 3.502 0 0 0-3.481 3.128L3 8.075 3 8c0-2.763 2.237-5 5-5 2.762 0 5 2.237 5 5 0 2.762-2.238 5-5 5-.025 0-.05-.028-.075-.028l.447-1.49Zm-7.153-1.84 6.403-1.882a.491.491 0 0 1 .619.62l-1.882 6.374c-.128.463-.725.516-.928.11l-.894-1.791c-.021-.069-.05-.081-.08-.116l-2.75 2.75a1 1 0 0 1-1.414-1.412l2.75-2.75a.556.556 0 0 0-.115-.082l-1.791-.893a.501.501 0 0 1 .082-.928Z"/>
    </svg>
)

export default class IconGoal extends PureComponent {
    render() {
        return <Icon color={this.props.color} size={this.props.size} style={this.props.style} baseline={this.props.baseline} className={this.props.className}><Element /></Icon>;
    }
}
